import { useTranslation } from '../../i18n/LanguageContext'
import AnvilIcon from './icons/AnvilIcon'
import ScrollIcon from './icons/ScrollIcon'
import CommunityIcon from './icons/CommunityIcon'
import './Features.css'

const Features = () => {
  const { t } = useTranslation()
  const features = [
    {
      icon: <AnvilIcon />,
      title: t('features.items.0.title'),
      description: t('features.items.0.desc'),
      color: 'blue'
    },
    {
      icon: <ScrollIcon />,
      title: t('features.items.1.title'),
      description: t('features.items.1.desc'),
      color: 'red'
    },
    {
      icon: <CommunityIcon />,
      title: t('features.items.2.title'),
      description: t('features.items.2.desc'),
      color: 'green'
    }
  ]

  return (
    <section className="features" id="recursos">
      <div className="features__container">
        <div className="features__grid">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`features__card features__card--${feature.color}`}
            >
              <div className="features__card-inner">
                <div className="features__icon-wrapper">
                  <div className="features__icon">
                    {feature.icon}
                  </div>
                </div>

                <div className="features__content">
                  <h3 className="features__title">{feature.title}</h3>
                  <p className="features__description">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
